var map = {
	"./campaign-logo-alphabet.svg": 548,
	"./campaign-logo-amazon.svg": 549,
	"./campaign-logo-coca-cola.svg": 550,
	"./campaign-logo-goldman-sachs.svg": 551,
	"./campaign-logo-hsbc.svg": 552,
	"./campaign-logo-ikea.svg": 553,
	"./campaign-logo-meta.svg": 554,
	"./campaign-logo-morgan-stanley.svg": 555,
	"./campaign-logo-oracle.svg": 556,
	"./campaign-logo-pwc.svg": 557,
	"./campaign-logo-walmart.svg": 558
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1322;